export default "__VITE_ASSET__tEpPXZSp__"